<div class="start-up-logo">
    <img src="images/logo/start-up-logo.svg" />
</div>